module.exports = __webpack_public_path__ + "static/main-754826a5233f06fd3029b6dd1bc7e6b2.gif";